import { ProviderPublic, ProviderStaticConfig } from '~/lib/model';
import { DEMO_PROVIDER_A, DEMO_PROVIDER_B, DEMO_LOCATION } from '~/tenants/demo/vars';

/**
 * The PUBLIC half of each provider's record: what may ship to the browser.
 * Email, phone and home address live in ./providers.server.ts and are merged
 * into these same objects on the server (tenants/providers.server.ts).
 */
const DEMO_PROVIDER_DATA_PUBLIC: Record<string, ProviderPublic<ProviderStaticConfig>> = {
  [DEMO_PROVIDER_A]: {
    first: 'Provider',
    last: 'A',
    schedule: true,
    headshot: 'avatar.jpg',
    location: DEMO_LOCATION,
  },
  [DEMO_PROVIDER_B]: {
    first: 'Provider',
    last: 'B',
    headshot: 'avatar.jpg',
    schedule: true,
    location: DEMO_LOCATION,
  },
};

/** Typed whole for the code that reads it; on the client the private fields are absent. */
export const DEMO_PROVIDER_DATA = DEMO_PROVIDER_DATA_PUBLIC as Record<string, ProviderStaticConfig>;
